import React from "react"
import {Link} from "react-router-dom"
import { useTranslation } from "react-i18next";

function MyPageButton(props) {
    const { t } = useTranslation();
    if (props.isLoggedIn) {
        return (
            <Link className="mypage-link" to="/mypage">{t("menu.mypage")}</Link>
        )
    } else {
        return ""
    }
}

export default MyPageButton
